
window.config = {
    title: 'SW Flow - QA',
    baseUri: 'https://api.swflow.asteria.work/',
    chatUri: 'https://api.swflow.asteria.work/signalr',
    chatHubsUrl: 'https://api.swflow.asteria.work/signalr/hubs',
    defaultImage: 'http://cdn.swflow.asteria.work/default.png',
    cdnUrl: 'https://cdn.swflow.com/',
    cdnUrlFilesTempPath: 'https://cdn.swflow.com/files/temp',
    version: '2.0',
    projectModule: 'SWFlow',
    rootLangFolder: '',
    defaultPageSize: 10,

    themeColor: '#0067b2',
    broswerConfig: '/images/Favicons/swflow-browserconfig.xml',
    faviconUrlApple: '/images/Favicons/swflow-apple-touch-icon.png',
    faviconUrl32: '/images/Favicons/swflow-favicon-32x32.png',
    faviconUrl16: '/images/Favicons/swflow-favicon-16x16.png',
    faviconUrl: '/images/Favicons/swflow-favicon.ico'
};

window.systemMessages = {
    sessionExpired: 'Sessão expirada. Por favor efetue o login novamente.'
};

window.enumerators = {
    statusApproval: { "Pendente": 1, "Aprovado": 2, "Reprovado": 3, "Cancelado": 4 },
    productSegment: { "ARCH": 1, "AERO": 2 },
    attachmentType: { "PromotionProof": 1, "Invoice": 2, "Mechanics": 3, "Layout": 4, "AcquittanceDoc": 5, "Financial": 6, "Design": 7, "Project": 8, "InvoiceSale": 9, "AuxDocuments": 10 },
    revenueType: { "YTD": 1, "FullYear": 2 },
    modules: { "Acoes": 1, "Cores": 2 },
    statusColor: { "EmEspera": 500, "AguardandoIniciodeProducao": 510, "EmProducao": 520, "AguardandoSolicitante": 530, "AguardandoAnaliseSW": 540, "RevisaoSolicitadaSW": 550, "ProjetoVerificado12": 560, "RevisaoSolicitadaConsumidor": 570, "ProjetoAprovado": 580, "ConcluidoVenda": 590, "ConcluidoSemVenda": 600, "ProjetoVerificado22": 610 },
    customersTypes: { "Revenda": 1, "Propria": 2 },
    disapprovalReasonsTypes: { "Consumidor": 1, "SemVenda": 2 },
    enumGroupsColorsRequests: { "VendedorBalcao": 1017, "Designer": 1018, "GerenteRegional": 1021, "Financeiro": 1024, "ControleQualidade": 1025, "GerenteNacional": 1026 },
    enumGroupsFlow: { "Vendedores": 1, "TradeMarketing": 2, "GerenciaRegional": 3, "GerenciaNacional": 4, "DiretoriaMarketing": 6, "AdmVendas": 7, "CoordenacaoAdmVendas": 8, "GerenciaAdmVendas": 9, "DiretoriaComercial": 10, "DiretoriaFinanceiro": 11, "Presidencia": 12, "Financeiro": 13, "GerenciaFPA": 14, "FPA": 15, "ComunicacaoMarketing": 16, "GerenciaTradeMKT": 1027, "CoordenadorTrade": 1038 }
};